<template>
  <v-container fluid class="backgrounColor">
    <v-row align="center" justify="center">
      <v-card max-width="75%" flat color="background">
        <v-row class="d-flex">
          <h1 class="mb-4">Sigue tu servicio</h1>
        </v-row>

        <v-row class="mb-6" align="center" justify="center">
          <h3>Tienes un servicio agendado con nosotros</h3>
        </v-row>

        <v-row align="center" justify="center">
          <img src="../assets/agendado.svg" width="40%" class="ma-3" />
        </v-row>

        <v-row align="center" justify="center">
          <v-col>
            <v-row class="d-flex align-center justify-start mt-4">
              <p>Fecha de entrega:</p>
            </v-row>
          </v-col>
          <v-col>
            <v-row class="d-flex align-center justify-end">
              <h3>{{ getDay(servicioData.deliveryDay) }}</h3>
            </v-row>
          </v-col>
        </v-row>

        <v-row align="center" justify="center">
          <v-col>
            <v-row class="d-flex align-center justify-start mt-4">
              <p>Hora estimada de llegada:</p>
            </v-row>
          </v-col>
          <v-col>
            <v-row class="d-flex align-center justify-end">
              <h3>{{ servicioData.deliveryTime.slice(0, 5) }} hrs</h3>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import Axios from "axios";
import { mapFields } from "vuex-map-fields";
import config from "../config"

export default {
  computed: {
    ...mapFields(["seguirServicioNumberUuid", "loader"]),
  },
  data() {
    return {
      servicioData: {},
    };
  },
  methods: {
    getDay(day) {
      switch (day) {
        case "today":
          return "Hoy";
          break;
        case "tomorrow":
          return "Mañana";
          break;
        case "sunday":
          return "Domingo";
          break;
        case "monday":
          return "Lunes";
          break;
        case "tuesday":
          return "Martes";
          break;
        case "wednesday":
          return "Miércoles";
          break;
        case "thursday":
          return "Jueves";
          break;
        case "friday":
          return "Viernes";
          break;
        case "saturday":
          return "Sábado";
          break;
        default:
          return day;
          break;
      }
    },
  },
  mounted() {
    if (this.seguirServicioNumberUuid) {
      this.loader = true;
      let api = Axios.get(
        config.apiBaseUrl + "/services/detail-customer/" + this.seguirServicioNumberUuid,
        {
          headers: {
            "x-api-key": config.apiKey,
          },
        }
      )
        .then((response) => {
          this.servicioData = response.data;
          this.loader = false;
        })
        .catch((error) => {
          console.error(error);
          this.loader = false;
          this.$router.push({ name: "Home" });
        });
    } else {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>

<style scoped>
.backgroundColor {
  background-color: #f1f3f6;
}
</style>